document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.shopify-section--header');
  if (!header) return;

  const updateHeaderHeight = () => {
    document.documentElement.style.setProperty('--header-height', `${header.clientHeight.toFixed(2)}px`);
  };

  updateHeaderHeight();

  if (window.ResizeObserver) {
    const resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(header);
  }
});
